import type { GraphNode } from "~/js/graph/node-socket-connection";
import { SocketEvents } from "~/js/types/IEventorListners";
import { findSocket } from "~/solidJs/shared/helpers/nodeHelpers";

export const PromptNullExecutor = (node: GraphNode) => {
	const inputSocket = findSocket("text_prompt", node);
	const outputSocket = node.outputSocketGroup.sockets[0];
	if (!inputSocket || !outputSocket) return;
	outputSocket.tryGetValue = () => inputSocket.tryGetValue();
	outputSocket.getValue = () => inputSocket.getValue();
	inputSocket.addListener(SocketEvents.Change, () => {
		outputSocket.eventor.invoke(SocketEvents.Change);
	});
	inputSocket.addListener(SocketEvents.ConnectionChange, () => {
		outputSocket.eventor.invoke(SocketEvents.Change);
	});
};
